// extracted by mini-css-extract-plugin
module.exports = {"menu_bar":"MenuBar_menu_bar___9Pa4","active_menu_item":"MenuBar_active_menu_item__dTkjz","menu_item":"MenuBar_menu_item__fMGB9"};